import { render } from "./dataprotection.vue?vue&type=template&id=230f767e&scoped=true"
import script from "./dataprotection.vue?vue&type=script&lang=js"
export * from "./dataprotection.vue?vue&type=script&lang=js"

import "./dataprotection.vue?vue&type=style&index=0&id=230f767e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230f767e"]])

export default __exports__